import { render, staticRenderFns } from "./RedotPayIntro.vue?vue&type=template&id=9efda888&scoped=true&"
import script from "./RedotPayIntro.vue?vue&type=script&lang=js&"
export * from "./RedotPayIntro.vue?vue&type=script&lang=js&"
import style0 from "./RedotPayIntro.vue?vue&type=style&index=0&id=9efda888&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9efda888",
  null
  
)

export default component.exports